export const detail =  {
    'TR':[
        [
            'Yapımcı', ['Sergin Akyaz']
        ],
        [
            'Senaryo', ['Sergin Akyaz']
        ],
        [
            'YÖNETMEN', [
                'Erhan Baytimur'
            ]
        ],
        [
            'Oyuncular', [
                'Atilla Taş',
                'Selim Naşit',
                'Perin Karaali',
                'Ruhi Sari',
                'Dilek Pamirtan',
                'Canan Öztürk'
            ]
        ]
    ],
    'Eng': [
        [
            'Country', ['Turkey']
        ],
        [
            'Language', ['Turkish']
        ],
        [
            'Executive Producer', ['Sergin Akyaz']
        ],
        [
            'Created by', ['Sergin Akyaz']
        ],
        [
            'Writer',  ['Sergin Akyaz']
        ],
        [
            'Director', [
                'Erhan Baytimur'
            ]
        ],
        [
            'Cast', [
                'Atilla Taş',
                'Selim Naşit',
                'Perin Karaali',
                'Ruhi Sari',
                'Dilek Pamirtan',
                'Canan Öztürk'
            ]
        ]
    ]
};